interface EffDay { date: string; task: number; email: number; call: number; meeting: number }
interface EffSnapshot { series: EffDay[]; summary: { handled7: number; arrived7: number; keepUpPct: number } }

const SEGMENTS = [
  { key: 'task', label: 'tasks', cls: 'bg-emerald-500/80' },
  { key: 'email', label: 'replies', cls: 'bg-blue-500/80' },
  { key: 'call', label: 'calls', cls: 'bg-violet-500/80' },
  { key: 'meeting', label: 'meetings', cls: 'bg-amber-500/80' },
] as const

function total(d: EffDay) { return d.task + d.email + d.call + d.meeting }

export default function EfficiencyChart({ snapshot }: { snapshot: EffSnapshot }) {
  const series = snapshot.series ?? []
  const { keepUpPct, handled7, arrived7 } = snapshot.summary
  const tone = keepUpPct >= 90 ? 'text-emerald-400' : keepUpPct >= 60 ? 'text-amber-400' : 'text-rose-400'

  if (series.length === 0 || series.every((d) => total(d) === 0)) {
    return (
      <div className="rounded-xl bg-card ring-1 ring-border/40 px-4 py-8 text-center text-sm text-muted-foreground/70">
        No activity in the last 30 days.
      </div>
    )
  }

  const max = Math.max(1, ...series.map(total))
  return (
    <div className="rounded-xl bg-card ring-1 ring-border/40 p-4">
      <div className="flex items-baseline gap-3 mb-3">
        <div className="text-xs font-semibold text-foreground uppercase tracking-wide">Efficiency · 30 days</div>
        <div className="ml-auto flex items-baseline gap-1.5">
          <span className={`text-2xl font-semibold tabular-nums ${tone}`}>{keepUpPct}%</span>
          <span className="text-[11px] text-muted-foreground">keep-up · 7d {handled7}/{arrived7}</span>
        </div>
      </div>
      <div className="flex items-end gap-[2px] h-24">
        {series.map((d) => (
          <div key={d.date} className="flex-1 flex flex-col-reverse" title={`${d.date}: ${d.task} tasks, ${d.email} replies, ${d.call} calls, ${d.meeting} meetings`}>
            {SEGMENTS.map((s) => (d[s.key] > 0 ? (
              <div key={s.key} className={`w-full ${s.cls}`} style={{ height: `${(d[s.key] / max) * 96}px` }} />
            ) : null))}
          </div>
        ))}
      </div>
      <div className="flex flex-wrap items-center gap-3 mt-2 text-[10px] text-muted-foreground">
        {SEGMENTS.map((s) => (
          <span key={s.key} className="flex items-center gap-1"><span className={`w-2 h-2 rounded-sm ${s.cls} inline-block`} />{s.label}</span>
        ))}
      </div>
    </div>
  )
}
